// src/utils/printBill.js

const printBill = ({
  invoiceNumber,
  cart,
  returnAmount = 0,
  payments,
  subTotal,
  grandTotal,
  totalPaid,
  balance,
  customerName,
  inventoryName,
  routeName
}) => {
  const now = new Date();
  const dateStr = now.toLocaleDateString('en-GB');
  const timeStr = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

  const itemRows = cart.map((item, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${item.productName}</td>
      <td>${item.categoryName}</td>
      <td style="text-align:right">${item.qty}</td>
      <td style="text-align:right">Rs. ${item.unitPrice.toFixed(2)}</td>
      <td style="text-align:right">Rs. ${item.totalPrice.toFixed(2)}</td>
    </tr>
  `).join('');

  const returnRow = returnAmount > 0 ? `
    <tr style="color: #c0392b;">
      <td colspan="5" style="text-align:right; font-style:italic;">Sale Return (Deduction)</td>
      <td style="text-align:right">- Rs. ${returnAmount.toFixed(2)}</td>
    </tr>
  ` : '';

  const paymentRows = payments.map(p => `
    <tr>
      <td>${p.type}</td>
      <td style="text-align:right">Rs. ${p.amount.toFixed(2)}</td>
    </tr>
  `).join('');

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Invoice ${invoiceNumber || ''}</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }

        body {
          font-family: Arial, sans-serif;
          font-size: 13px;
          padding: 32px;
          width: 100%;
          max-width: 800px;
          margin: 0 auto;
          color: #111;
        }

        .header {
          text-align: center;
          margin-bottom: 24px;
        }
        .header h1 {
          font-size: 24px;
          font-weight: bold;
          letter-spacing: 1px;
          margin-bottom: 4px;
        }
        .header p {
          font-size: 13px;
          color: #444;
          line-height: 1.6;
        }

        .meta-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 24px;
          gap: 32px;
        }
        .meta-block { flex: 1; }
        .meta-block p { margin-bottom: 4px; line-height: 1.6; }
        .meta-block strong { display: inline-block; min-width: 110px; }

        .section-title {
          font-size: 13px;
          font-weight: bold;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 2px solid #111;
          padding-bottom: 4px;
          margin-bottom: 10px;
          margin-top: 20px;
        }

        table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
        thead tr { background-color: #f0f0f0; }
        th { text-align: left; padding: 7px 8px; font-size: 12px; border-bottom: 1px solid #ccc; }
        td { padding: 6px 8px; font-size: 13px; border-bottom: 1px solid #eee; }
        tbody tr:last-child td { border-bottom: none; }

        .totals-section { display: flex; justify-content: flex-end; margin-top: 12px; }
        .totals-table { width: 280px; }
        .totals-table td { padding: 5px 8px; border: none; }
        .totals-table .subtotal-row td { color: #555; }
        .totals-table .return-row td { color: #c0392b; }
        .totals-table .grand-total-row td {
          font-size: 15px;
          font-weight: bold;
          border-top: 2px solid #111;
          padding-top: 8px;
        }

        .payments-section { display: flex; justify-content: flex-end; }
        .payments-table { width: 280px; }

        .footer {
          text-align: center;
          margin-top: 40px;
          padding-top: 16px;
          border-top: 1px dashed #aaa;
          color: #555;
          font-size: 12px;
          line-height: 1.8;
        }
        .footer strong { font-size: 15px; color: #111; }

        @media print {
          body { padding: 0; }
          @page { margin: 20mm; size: A4 portrait; }
        }
      </style>
    </head>
    <body>

      <!-- Header -->
      <div class="header">
        <h1>SAYUL REDISTRIBUTIONS</h1>
        <p>NO 244/2/A, Makola North, Makola</p>
        <p>Tel: +94 77 222 2700</p>
      </div>

      <!-- Invoice Meta -->
      <div class="meta-row">
        <div class="meta-block">
          <p><strong>Invoice #:</strong> ${invoiceNumber || 'N/A'}</p>
          <p><strong>Date:</strong> ${dateStr}</p>
          <p><strong>Time:</strong> ${timeStr}</p>
        </div>
        <div class="meta-block">
          <p><strong>Customer:</strong> ${customerName}</p>
          <p><strong>Warehouse:</strong> ${inventoryName}</p>
          <p><strong>Route:</strong> ${routeName}</p>
        </div>
      </div>

      <!-- Products -->
      <div class="section-title">Products</div>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Product</th>
            <th>Category</th>
            <th style="text-align:right">Qty</th>
            <th style="text-align:right">Unit Price</th>
            <th style="text-align:right">Line Total</th>
          </tr>
        </thead>
        <tbody>
          ${itemRows}
          ${returnRow}
        </tbody>
      </table>

      <!-- Totals -->
      <div class="totals-section">
        <table class="totals-table">
          <tbody>
            ${returnAmount > 0 ? `
            <tr class="subtotal-row">
              <td>Subtotal</td>
              <td style="text-align:right">Rs. ${subTotal.toFixed(2)}</td>
            </tr>
            <tr class="return-row">
              <td>Return Deduction</td>
              <td style="text-align:right">- Rs. ${returnAmount.toFixed(2)}</td>
            </tr>
            ` : ''}
            <tr class="grand-total-row">
              <td>Grand Total</td>
              <td style="text-align:right">Rs. ${grandTotal.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Payments -->
      <div class="section-title">Payments</div>
      <div class="payments-section">
        <table class="payments-table">
          <thead>
            <tr>
              <th>Method</th>
              <th style="text-align:right">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${paymentRows}
            <tr>
              <td><strong>Total Paid</strong></td>
              <td style="text-align:right"><strong>Rs. ${totalPaid.toFixed(2)}</strong></td>
            </tr>
            <tr>
              <td><strong>${balance >= 0 ? 'Change' : 'Balance Due'}</strong></td>
              <td style="text-align:right"><strong>Rs. ${Math.abs(balance).toFixed(2)}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer -->
      <div class="footer">
        <p><strong>THANK YOU FOR YOUR BUSINESS!</strong></p>
        <p>Please keep this invoice for your records.</p>
        <p style="margin-top:8px; color:#aaa;">software by @fidesm.dev | +94 75 718 0225</p>
      </div>

      <script>
        window.onload = function () {
          window.print();
          window.onafterprint = function () { window.close(); };
        };
      </script>
    </body>
    </html>
  `;

  const win = window.open('', '_blank', 'width=900,height=700');
  if (win) {
    win.document.write(html);
    win.document.close();
  }
};

export default printBill;
